const subDomain = (window.location.host === "www.startfreept.com" ||
    window.location.host === "startfreept.com" ||
    window.location.host === "virdiohealth.com" ||
    window.location.host === "www.virdiohealth.com")
    ? "api" : "uatapi";

const CHAT_API_URL = `https://${subDomain}.virdiohealth.com/api/v1/assessment/chat`;

const MyraChatService = {
    /**
     * Send a user message and get Myra's response.
     * @param {string} userMessage - The text the user typed
     * @param {string} sessionId - The analytics session ID (window.trSessionId)
     * @param {Array} conversationHistory - Array of {role, content} objects for context
     * @param {number} turnNumber - The current turn number in the conversation
     * @returns {Promise<{response: string, conversationHistory: Array}>}
     */
    sendMessage: async (userMessage, sessionId, conversationHistory = [], turnNumber, screenPayload = {}, screenName = "") => {
        try {
            const gsaStep = screenPayload?.gsa_step || screenName;
            const payload = {
                session_id: sessionId,
                message: userMessage,
                conversation_history: conversationHistory,
                turnNumber: turnNumber || 0,
                source: gsaStep,
                timestamp: new Date().toISOString(),
                screenPayload: screenPayload,
                flow: window.currentFlow || window.VoiceService._currentFlow || "unknown_flow"
            };
            console.log("Sending chat payload:", payload);

            const response = await fetch(CHAT_API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error("Chat API error");

            const data = await response.json();
            console.log("Received chat response:", data);
            const action = data?.data?.action;
            const value = data?.data?.value;
            const speech = data?.response;
            const intent = data?.data?.intent;
            const moveAction = data?.MoveAction

            if (action && window.currentCommandsAudio?.[action]) {
                const now = Date.now();
                if (now - (MyraChatService._lastCallTime || 0) > 500) {
                    console.log(`[CHAT] Executing command handler: ${action}`);
                    window.currentCommandsAudio[action](value, speech, intent);
                    MyraChatService._lastCallTime = now;
                } else {
                    console.log('[CHAT] Too fast call, skipping');
                }
            }
            return {
                response: data.response,
                moveAction: moveAction ? true : false,
                action: action,
                value: data.value,
                conversationHistory: data.history,
                intent: data.intent || null,
                conditions: data.conditions || null,
                turnNumber: data.turnNumber || 0
            };
        } catch (error) {
            console.error("MyraChatService.sendMessage Error:", error);
            return {
                response: "I'm having trouble connecting right now. You can try again, or tap the mic to talk to me instead.",
                conversationHistory,
            };
        }
    },
};

export default MyraChatService;